import { useMemo } from 'react'

import { IAnnualProgram } from '@/_types'

import { useAPDetailGender } from '../_components/ap-detail'

/**
 * Hook to get the current program based on selected gender.
 * Memoizes the program selection to avoid unnecessary re-renders.
 *
 * @param maleProgram - Annual program for male category
 * @param femaleProgram - Annual program for female category
 * @returns The currently selected program based on gender
 *
 * @example
 * ```typescript
 * const currentProgram = useAPDetailProgram(maleProgram, femaleProgram)
 * ```
 */
export const useAPDetailProgram = (
	maleProgram: IAnnualProgram,
	femaleProgram: IAnnualProgram
): IAnnualProgram => {
	const { gender } = useAPDetailGender()

	return useMemo(
		() => (gender === 'male' ? maleProgram : femaleProgram),
		[gender, maleProgram, femaleProgram]
	)
}
